import React from 'react'
import {Avatar, Button, Popover, Table} from 'antd'

const basicCustomerColumns = [
  {
    dataIndex: 'avatar',
    render: text => <Avatar src={text}/>,
  }, {
    title: 'Name',
    dataIndex: 'name',
  }, {
    title: 'Surname',
    dataIndex: 'surname',
  }, {
    title: 'Email',
    dataIndex: 'email',
    render: text => <a href={'mailto:' + text}>{text}</a>,
  }
]

export const mainListColumns = [
  ...basicCustomerColumns,
  {
    dataIndex: 'uuid',
    title: '',
    render: () => <Button>Invoices</Button>,
  },
]

export const itemsFromOrderColumns = [
  {
    dataIndex: 'productName',
    title: 'Name',
  }, {
    dataIndex: 'count',
    title: 'Count',
  }, {
    dataIndex: 'price',
    title: 'Price',
    render: (text, row) => <div style={{textAlign: 'right'}}>{text} {row.currencyIsoId}</div>
  }
]

const InvoiceOrderItemsList = ({data}) => (
  <Table
    rowKey='uuid'
    size='small'
    pagination={false}
    dataSource={data}
    columns={itemsFromOrderColumns}
    style={{
      padding: 'none',
      border: 'none',
    }}
  />
)

export const invoicesColumns = [
  {
    dataIndex: 'businessName',
    title: 'From',
  }, {
    dataIndex: 'ownerType',
    title: 'Owner',
  }, {
    dataIndex: 'street',
    title: 'Street',
  }, {
    dataIndex: 'city',
    title: 'City',
  }, {
    dataIndex: 'country',
    title: 'Country',
  }, {
    dataIndex: 'items',
    title: 'Number of items',
    render: array => (
      <Popover content={<InvoiceOrderItemsList data={array}/>} trigger='click'>
        {array.length} <Button type='link'>Show list</Button>
      </Popover>
    ),
  },
]

export default basicCustomerColumns
